import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import {cryptoJs} from '@deanwu/vue-component-library-mobile'
import dictList from './dict.js'
import {RE, SERVER_ADDR} from '@/config.js'

const dictData = {};
for (let key in dictList) {
	dictData[key] = stateSerialize(dictList[key]);
}
function stateSerialize(data) {
	let json = {};
	data.forEach(item => {
		if (typeof item.value == 'object') {
			item.value.forEach(i => {
				json[i] = item;
			});
		} else {
			json[item.value] = item;
		}
	});
	
	return json;
}

Vue.use(Vuex);

let app = new Vue();
const Store = new Vuex.Store({
	state: {
		...dictList,
		dictData: {
			...dictData
		},
		asyncDictList: {},
		asyncDictData: {},
		ENV: 'browser',
		deviceInfo: {},  // 设备信息
		session: '',
		saasInfo: {},
		userInfo: {},
		authList: [],
		systemConfig: null,
		cacheData: {}
	},

	getters: {
		allAuthKey(state) {
			return state.authList.map(item => item.key);
		},

		freeAuthKey(state) {
			return state.authList.filter(item => !item.vip).map(item => item.key);
		},

		scanAuth(state) {
			return true;
			return state.ENV == 'browser' ? state.deviceInfo.cameraDevice : true;
		},

		/**当前商户是否有接驳作业：无接驳的版本（门店版）商品不离开门店，调拨/返库这类纯接驳动作与在途类写死列都不摆出来；
		   能力开关由登录信息下发（版本判定只在服务端 EditionCapabilityService 一处），端内不拿版本编码判等；
		   老会话的持久化缓存里没有这个开关时按有接驳处理，与服务端保守兜底口径一致*/
		hasHandover(state) {
			let capability = state.saasInfo && state.saasInfo.edition_capability;
			return !capability || capability.has_handover !== false;
		}
	},

	mutations: {
		updateAsyncDict(state, data) {
			Vue.set(state.asyncDictList, data.dict, data.data);
			Vue.set(state.asyncDictData, data.dict, stateSerialize(data.data));
		},
		
		setSystemConfig(state, data) {
			state.systemConfig = data;
		},

		setENV(state, data) {
			state.ENV = data;
		},

		setDeviceInfo(state, data) {
			state.deviceInfo = Object.assign(state.deviceInfo, data);
		},
		
		setSession(state, data) {
			state.session = data;
		},
		
		// 设置企业信息
		setSaasInfo(state, data) {
			state.saasInfo = data;
		},
		
		// 设置用户信息
		setUserInfo(state, data) {
			delete data.session;
			state.userInfo = data;
		},
		
		// 设置权限列表
		setAuth(state, data) {
			state.authList = data;
		},
		
		setCache(state, data) {
			state.cacheData[data.name] = data.data;
		}
	},

	actions: {
		updateSystemConfig(store) {
			app.request({
				url: '/sys/config',
				success: data => {
					store.commit('setSystemConfig', data);
				}
			});
		},

		updateLoginInfo(store, callback) {
			app.request({
				url: '/sys_user/get_login_info',
				success: data => {
					store.dispatch('setLoginInfo', data);
					callback && callback();
				}
			})
		},

		setLoginInfo(store, data) {
			store.commit('setSession', data.user_info.session);
			store.commit('setUserInfo', data.user_info);
			store.commit('setSaasInfo', data.saas_info || {});
			store.commit('setAuth', data.user_menu_key_list.map(item => {
				return {
					key: item.menu_unique_key,
					vip: item.is_vip == 1
				}
			}));
		},
		
		getAsyncDict(store, dict) {
			store.commit('updateAsyncDict', {
				dict: dict,
				data: []
			});
			
			app.request({
				url: '/dic/info/options',
				data: {
					dic_type_code: dict
				},
				success: data => {
					store.commit('updateAsyncDict', {
						dict,
						data
					});
				}
			})
		}
	},

	plugins: [createPersistedState({
		key: 'session',
		paths: ['session', 'saasInfo', 'userInfo', 'authList'],
		storage: {
			getItem(key) {
				try {
					return JSON.parse(cryptoJs.AES.decrypt(localStorage.getItem(key), 'session').toString(cryptoJs.enc.Utf8));
				} catch(e) {
					return undefined;
				}
			},
			
			setItem(key, val) {
				localStorage.setItem(key, cryptoJs.AES.encrypt(JSON.stringify(val), 'session').toString());
			},
			
			removeItem(key) {
				localStorage.removeItem(key);
			}
		}
	})]
});
export default Store

const asyncMapState = function(data) {
	const res = {};
	data.forEach(dict => {
		res[dict] = {
			get() {
				if (!Store.state.asyncDictList[dict]) {
					Store.dispatch('getAsyncDict', dict);
				}
				
				return Store.state.asyncDictList[dict];
			},
			set() {}
		}
	});
	return res;
}
export {
	asyncMapState
}
